import { prepareSignBytes } from './utils.js';
import { objectKeysToEip712Types } from '../tx/eip712/maps.js';
/**
 * @category Messages
 */
export class MsgBase {
    params;
    constructor(params) {
        this.params = params;
    }
    /** @deprecated - use toWeb3Gw instead, renamed for clarity */
    toWeb3() {
        return this.toWeb3Gw();
    }
    toJSON() {
        return JSON.stringify(prepareSignBytes(this.toData()));
    }
    /**
     * Returns the types of the message for EIP712
     */
    toEip712Types() {
        const amino = this.toAmino();
        return objectKeysToEip712Types({
            object: amino.value,
            messageType: amino.type,
        });
    }
    /**
     * Returns the values of the message for EIP712
     */
    toEip712() {
        return this.toAmino();
    }
    /**
     * Returns the values of the message for EIP712_V2
     */
    toEip712V2() {
        return this.toWeb3Gw();
    }
    toDirectSignJSON() {
        return JSON.stringify(prepareSignBytes(this.toDirectSign()));
    }
}
